<template lang="pug">
    .re-login
        .re-login-box
            .re-container-form
                .re-form-head
                    h2.box-form-title {{ title }}
                    p.box-form-head-message(v-if="showNotice" v-html="notice")
                    .re-registration-plug
                        .register-container {{ $$t('register.label') }} 
                            router-link(:to="{ name: $$s('register.route') }") {{ $$t('register.link') }}
                    p.box-form-head-error(v-show="!!formErrorMessage" v-html="formErrorMessage")
                .re-form-body
                    .login-inputs-box
                        .re-inp-box.re-inp-box--with-icon
                            re-input(
                                v-model.trim="$v.fields.username.$model"
                                v-bind="getFieldProps('username', {type: 'email', defaults: {label: 'Email'}})"
                            )
                            .re-inp-box__icon
                                img(:src="`${baseUri}/images/client/lairdnd/input-icon-envelope.svg`")
                        .re-inp-box.re-inp-box--with-icon
                            re-input(
                                v-model.trim="$v.fields.password.$model"
                                v-bind="getFieldProps('password', {type: 'password', defaults: {label: 'Password'}})"
                                :type="showPassword ? 'text' : 'password'"
                            )
                            re-input-eye-icon(v-model="showPassword")
                        .re-inp-box.re-input-box--flex
                            re-checkbox(v-model="fields.remember_me") {{ $$t('rememberMe.label') }}
                            router-link.re-forgot-password(:to="{ name: $$s('forgotPassword.route') }") {{ $$t('forgotPassword.label', 'Forgot Password?') }}
                    .re-submit-button-container
                        re-button.btn-primary.btn-lg.re-submit-button(@click="loginNow" :loading="isLoggingIn") {{ submitButtonTitle }}

        re-modal.verify-account-error(v-if="showingVerificationError" container-class="re-modal-sm" @close="showingVerificationError = false")
            .re-modal-title Registration not verified
            .re-modal-content
                re-verify-account-error(:email="verificationEmail" resetTitle="" resetButtonTitle="Resend" resetButtonClass="btn-primary btn-lg mt-2" resetAgainButtonClass="btn-primary btn-lg mt-2")

</template>

<script>
import ReLogin from 'utils/vue/components/complex/user/re-login/script.js'
import { EventBus } from 'utils/vue/components/complex/user/re-login/config'

export default {
    name: 'lairdnd-login',

    mixins: [
        ReLogin,
    ],

    created() {
        EventBus.$on('user.login.success', () => {
            this.$store.dispatch('Shop/Orders/Cart/clearCart')
        })
    },

    data() {
        return {
            showPassword: false,
            fields: {
                remember_me: false,
            },
        }
    },
}
</script>
